import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const informationsSlice = createSlice({
    name: 'informations',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInformations.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchInformations.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchInformations.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(editInformation.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editInformation.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(editInformation.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
           

            .addCase(editLogo.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editLogo.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(editLogo.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            
    },
})

// Async thunk action to fetch data from the API
export const fetchInformations = createAsyncThunk(
    'informations/fetch',
    async (payload) => {
        try {
            const response = await BaseService.post(
                `/XML/info/arr_info`,{'arr_info':'CNSS,Raison social,IF,RC,ICE,adresse,contact,e_mail,ville,TVA,mode_TVA,format_num_fact,numAutoFactures,'}
            )
            const token = await BaseService.post(
                `/XML/info/getTokenApi`,{}
            )

            const logo = await BaseService.get(
                `/XML/info/getLogoReact`
            )
            const objetdata = {}
            response?.data?.map((item)=>{
                objetdata[item.info] = item.contenu
            })
            objetdata['token'] = token?.data
            objetdata['logo'] = logo?.data
            return objetdata
        } catch (error) {
            throw new Error('Failed to fetch informations')
        }
    }
)



export const editInformation = createAsyncThunk(
    'informations/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
      
        try {
            const response = await BaseService.post('/XML/info.send/infoReact', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)




export const editLogo = createAsyncThunk(
    'logo/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
      
        try {
            const response = await BaseService.post('/XML/info.send/logo', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)


export const genereteToken = createAsyncThunk(
    'logo/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
      
        try {
            const response = await BaseService.post('/XML/info.send/generateTokenApi', {})
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)
export const selectData = (state) => state.informations.data
export const selectIsLoading = (state) => state.informations.isLoading
export const selectError = (state) => state.informations.error
export const selectIsDeleted = (state) => state.informations.isDeleted
export const selectCurrentPage = (state) => state.informations.currentPage
export default informationsSlice.reducer
